// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ObNT","notes":"Notes_notes__2Ps-3"};